// imove-behavior: 跳转指定页面

export default async function(ctx) {
  const {query} = ctx.payload;
  // redirect_url为转译后完整页面链接
  if(query?.redirect_url){
      ctx.emit('replacePage',query?.redirect_url);
      return;
  }
  const redirectLink = query?.redirect_path||'/home';
  ctx.emit('routerPage',redirectLink);
}